import React from 'react'
import cx from 'classnames'

import './FlowForm.css'

const FlowForm = ({ className, children, ...props }) => (
  <form
    {...props}
    className={cx('flow__form buyflow-v3 form-design-v4', className)}>
    {children}
  </form>
)

export default FlowForm
